import { render, staticRenderFns } from "./comTalent.vue?vue&type=template&id=bb7c949a&scoped=true"
import script from "./comTalent.vue?vue&type=script&lang=js"
export * from "./comTalent.vue?vue&type=script&lang=js"
import style0 from "./comTalent.vue?vue&type=style&index=0&id=bb7c949a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7c949a",
  null
  
)

export default component.exports